module.exports = __webpack_public_path__ + "static/p08_cerdoGrandeOrejaIzq-2a7868f5366b795ea7e6d4d734d465a0.png";